import React from 'react';
import { createRoot } from 'react-dom/client';

import { QueryClientProvider } from '@mint-lib/query-client';
import { MintServiceLocator } from '@mint-lib/routing-context';
import {
  routerContext,
  routerInstance,
  RouterProvider,
} from '@mint/emails-routing';

async function bootstrap() {
  const queryClient =
    await routerContext.serviceLocator.getOrThrowInstance('queryClient');
  return createRoot(document.getElementById('root') as Element).render(
    <React.StrictMode>
      <MintServiceLocator.Provider value={routerContext.serviceLocator}>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={routerInstance} />
        </QueryClientProvider>
      </MintServiceLocator.Provider>
    </React.StrictMode>,
  );
}

bootstrap().catch((error) => {
  console.error('Error bootstrapping the app:', error);
});
